<template>
  <div id="login">
    <p>whatsapp 商业版</p>
    <van-field v-model="loginData.LoginName" label="账户" placeholder="请输入用户名" />
    <van-field type="password" v-model="loginData.PassWord" label="密码" placeholder="请输入密码" />
    <van-button class="loginBtn" type="info" @click="loginFn">登录</van-button>
  </div>
</template>
<script>
import { Toast } from 'vant-green'
import {WxLogin} from '../http/api'
export default {
  data () {
    return {
      defaultValue: '',
      loginData: {
        LoginName: '',
        PassWord: ''
      }
    }
  },
  methods: {
    loginFn () {
      console.log(this.loginData)
      if (this.loginData.LoginName.length === 0) {
        Toast('请输入账号！')
        return
      }
      if (this.loginData.PassWord.length === 0) {
        Toast('请输入密码！')
        return
      }
      WxLogin(this.loginData).then(response => {
        if (response.code === 200 && response.result) {
          localStorage.setItem('flagMig', response.result.token.token)
          this.$router.push({path: '/home'})
        }
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
  #login>p{text-align: center;margin: 60px auto 40px;font-size: 20px;color: #333;}
  .loginBtn{display: block;width: 90%;margin: 120px auto 0;}
</style>



// WEBPACK FOOTER //
// src/view/login.vue